import { useLoadedFlagValue } from '@/utils/sharedHooks'
import { FEATURE_FLAG_KEYS } from '@/flags'
import { ReactNode } from 'react'

export const FlaggedComponent = ({
  flagKey,
  trueComponent,
  falseComponent,
  loadingComponent = null,
}: {
  flagKey: FEATURE_FLAG_KEYS
  trueComponent: ReactNode
  falseComponent: ReactNode
  loadingComponent?: ReactNode | null
}) => {
  const flagValue = useLoadedFlagValue(flagKey, false)

  if (flagValue === null) {
    return loadingComponent
  }

  return flagValue ? trueComponent : falseComponent
}
